import { _showAppLogs } from "../LogContext";

export const shouldUseCache = (timestamp_cache, timestamp_db, cache_groupType, timestamp_this) => {
  // If the document was updated *after* the cache, ignore the cache

  console.log('⚡ shouldUseCache', `${cache_groupType}`, `TSinCache:${timestamp_cache}-TSfromDB:${timestamp_db}`, timestamp_db > timestamp_cache, timestamp_db !== timestamp_cache)

  const aaa = 1770655641418 > 1771347697854
  console.log('aaa', aaa)
  // 1771347697854
  // 1770655641418

  // Timestamps are just numbers counting milliseconds since epoch — smaller = older
  if (timestamp_db > timestamp_cache) {
    if (_showAppLogs.eventInfo) {
      console.group('Should useCache', cache_groupType)
      console.log(`🚫 Ignore cache data for ${cache_groupType}.`);
      console.log('timestamp_cache', timestamp_cache);
      console.log('timestamp_db', timestamp_db);
      // console.log('timestamp_this', timestamp_this)
      console.groupEnd()
    }
    return false; // ignore cache
  }
  _showAppLogs.eventInfo && console.log(`✅ CD ${cache_groupType}!`);
  return true; // cache is still valid
};